import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ARStatementsViewModel } from '@payments/models/ar-statements-view.model';

@Component({
  selector: 'app-ar-statements-row',
  templateUrl: './ar-statements-row.component.html',
  styleUrls: ['./ar-statements-row.component.scss'],
})
export class ArStatementsRowComponent {
  @Input() vm: ARStatementsViewModel;
  @Input() isDesktop: boolean;
  @Output()
  arStatementRowClickEmitter = new EventEmitter<ARStatementsViewModel>();
  @Output() moreOptionsClickEmitter: EventEmitter<{
    event: Event;
    arStatement: ARStatementsViewModel;
  }> = new EventEmitter();

  onArStatementRowClick() {
    this.arStatementRowClickEmitter.emit(this.vm);
  }

  onMoreOptionClick(event: Event) {
    this.moreOptionsClickEmitter.emit({
      event,
      arStatement: this.vm,
    });
  }

  get statementDate() {
    return new Date(
      Date.UTC(
        this.vm.statementDate / 10000,
        (this.vm.statementDate % 10000) / 100 - 1,
        this.vm.statementDate % 100,
      ),
    );
  }
}
